import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { About } from './components/About';
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import {Experience} from "./components/Experience";
import {Resume} from "./components/Resume"
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() {
  return (
    <Router>
      <NavBar />
      <Routes className="App">
        <Route path="/" element={<> <Banner /> <About /> <Skills/> </>} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/experience" element={<Experience />} />
        <Route path="/resume" element={<Resume/>} />
      </Routes>
      <Contact />
      <Footer />
    </Router>
  );
}

export default App;
